(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const navigationEntry =
    typeof performance !== 'undefined' &&
    typeof performance.getEntriesByType === 'function' &&
    performance.getEntriesByType('navigation')[0];
  const isReloadNavigation =
    navigationEntry?.type === 'reload' ||
    (typeof performance !== 'undefined' &&
      performance.navigation &&
      performance.navigation.type === performance.navigation.TYPE_RELOAD);

  if (url.hash) {
    if (isReloadNavigation) {
      if (window.history && window.history.replaceState) {
        url.hash = '';
        window.history.replaceState(window.history.state, '', url.toString());
      }
    } else {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });

            if (window.history && window.history.replaceState) {
              const restoredUrl = new URL(window.location.href);
              restoredUrl.hash = '';
              window.history.replaceState(window.history.state, '', restoredUrl.toString());
            }
          }
        },
        { once: true }
      );
    }
  }

  if (!window.__smfMobileCollectionSwitcherBound) {
    window.__smfMobileCollectionSwitcherBound = true;

    function getSmfMobileCollectionSwitcherElements() {
      var root = document.querySelector('[data-smf-mobile-collection-switcher]');

      if (!root) return null;

      return {
        root: root,
        trigger: root.querySelector('[data-smf-mobile-collection-switcher-trigger]'),
        menu: root.querySelector('[data-smf-mobile-collection-switcher-menu]')
      };
    }

    function setSmfMobileCollectionSwitcherOpenState(isOpen) {
      var elements = getSmfMobileCollectionSwitcherElements();

      if (!elements || !elements.trigger || !elements.menu) return;

      elements.root.classList.toggle('is-open', !!isOpen);
      elements.trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      elements.menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    document.addEventListener('click', function(event) {
      var elements = getSmfMobileCollectionSwitcherElements();

      if (!elements || !elements.trigger || !elements.menu) return;

      if (elements.trigger.contains(event.target)) {
        event.preventDefault();
        setSmfMobileCollectionSwitcherOpenState(
          !elements.root.classList.contains('is-open')
        );
        return;
      }

      if (!elements.root.contains(event.target)) {
        setSmfMobileCollectionSwitcherOpenState(false);
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        setSmfMobileCollectionSwitcherOpenState(false);
      }
    });

    window.addEventListener(
      'scroll',
      function() {
        setSmfMobileCollectionSwitcherOpenState(false);
      },
      { passive: true }
    );

    window.addEventListener('resize', function() {
      if (window.matchMedia && window.matchMedia('(min-width: 750px)').matches) {
        setSmfMobileCollectionSwitcherOpenState(false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
